import React, { useEffect, useState } from "react";
import {
  Modal,
  Row,
  Col,
  Form,
  FormGroup,
  Label,
  Input,
  Button,
} from "reactstrap";
import LoadingModal from "components/Common/ModalSpinner";

const AddServicoModal = ({
  isOpen,
  toggle,
  onServicoAdicionado,
  servicoEditavel,
}) => {
  const [areas, setAreas] = useState([]);
  const [areaSelecionada, setAreaSelecionada] = useState("");
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState("");
  const [valorParcelado, setValorParcelado] = useState("");
  const [valorParcelado6x, setValorParcelado6x] = useState("");
  const [status, setStatus] = useState("");
  const [mensagemAserExibida, setMensagemAserExibida] = useState("");
  const [parcelas, setParcelas] = useState();
  const [loading, setLoading] = useState(false);
  const [text, setText] = useState("");

  const TAXA_FIXA = 0.49;
  const TAXA_PERCENTUAL = 0.0349;
  const TAXA_ANTECIPACAO_MENSAL = 0.0249;

  useEffect(() => {
    async function fetchAreas() {
      try {
        const response = await fetch(`${process.env.REACT_APP_API}/areas`);
        const data = await response.json();
        setAreas(data);
      } catch (error) {
        console.error("Erro ao buscar áreas:", error);
      }
    }

    fetchAreas();
  }, []);

  useEffect(() => {
    if (servicoEditavel) {
      setAreaSelecionada(servicoEditavel.AreaID);
      setDescricao(servicoEditavel.Nome);
      setValor(servicoEditavel?.Preco?.toString().replace(".", ","));
      setValorParcelado(
        servicoEditavel?.Preco_parcelado?.toString().replace(".", ",")
      );
      setStatus(servicoEditavel.status === 1 ? "Ativo" : "Inativo");
      calcularValorParaReceber(
        servicoEditavel.Preco.toString().replace(".", ",")
      );
      setMensagemAserExibida(servicoEditavel.mensagemAserExibida);
      setParcelas(servicoEditavel.Parcelas);
    } else {
      setAreaSelecionada("");
      setDescricao("");
      setValor("");
      setValorParcelado("");
      setValorParcelado6x("");
      setMensagemAserExibida("");
      setStatus("");
    }
  }, [servicoEditavel]);

  useEffect(() => {
    if (!servicoEditavel) {
      calcularValorParaReceber(valor);
    }
  }, [valor]);

  const calcularValorParaReceber = (valorDesejado) => {
    if (!valorDesejado) {
      setValorParcelado("");
      setValorParcelado6x("");
      return;
    }

    const valorNumerico = parseFloat(valorDesejado.replace(",", "."));
    const parcelasComJuros = [];

    // Primeira parcela (1x) é o valor desejado sem qualquer taxa ou juros
    parcelasComJuros.push(valorNumerico);

    // Cálculo das parcelas de 2x a 6x com taxas e juros a partir da segunda parcela
    for (let i = 2; i <= 6; i++) {
      // Valor base por parcela sem taxas
      const valorParcelaBase = valorNumerico / i;
      // Aplica a taxa percentual e fixa por parcela
      const valorParcelaSemAntecipacao =
        valorParcelaBase / (1 - TAXA_PERCENTUAL) + TAXA_FIXA;
      // Aplica a taxa de antecipação composta para o número de meses (i-1)
      const taxaAntecipacaoTotal = Math.pow(1 + TAXA_ANTECIPACAO_MENSAL, i - 1);
      const valorParcelaComJuros =
        valorParcelaSemAntecipacao * taxaAntecipacaoTotal;
      // Total para essa quantidade de parcelas
      const valorTotalComJuros = valorParcelaComJuros * i;
      parcelasComJuros.push(valorTotalComJuros);
    }

    // Define o valor parcelado como o total em 6x (apenas para referência)
    const totalEm6x = parcelasComJuros[5];
    setValorParcelado(totalEm6x.toFixed(2).toString().replace(".", ","));

    // Monta a string de exibição para todas as parcelas
    const textoParcelas = parcelasComJuros
      .map((valorTotal, i) => {
        const valorPorParcela = (valorTotal / (i + 1)).toFixed(2);
        return `${i + 1}x de R$ ${valorPorParcela.replace(".", ",")}`;
      })
      .join(" | ");

    setValorParcelado6x(textoParcelas);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    setLoading(true);

    if (!areaSelecionada || !descricao || !valor || !status) {
      onServicoAdicionado("Preencha todos os campos!", "error");
      return;
    }

    let valorAux = parseFloat(valor.replace(",", "."));
    valorAux = valorAux.toFixed(2);

    let valorParceladoAux = parseFloat(valorParcelado.replace(",", "."));
    valorParceladoAux = valorParceladoAux.toFixed(2);

    const novoServico = {
      AreaID: areaSelecionada,
      Nome: descricao,
      Preco: valorAux,
      Preco_parcelado: valorParceladoAux,
      status: status === "Ativo" ? 1 : 0,
      Mensagem_a_ser_exibida: mensagemAserExibida,
    };

    console.log({ novoServico });

    const url = servicoEditavel
      ? `${process.env.REACT_APP_API}/subservicos/${servicoEditavel.SubservicoID}`
      : `${process.env.REACT_APP_API}/subservicos`;
    const method = servicoEditavel ? "PUT" : "POST";

    setText(
      servicoEditavel
        ? "Aguarde, atualizando serviço..."
        : "Aguarde, adicionando serviço..."
    );

    try {
      const response = await fetch(url, {
        method,
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(novoServico),
      });
      const data = await response.json();
      if (data.error) {
        onServicoAdicionado(data.message, "error");
        setLoading(false);
      } else {
        onServicoAdicionado("Serviço adicionado com sucesso!", "success");
        setLoading(false);
        toggle();
      }
    } catch (error) {
      console.error("Erro ao adicionar serviço:", error);
      onServicoAdicionado("Erro ao adicionar serviço!", "error");
    }
  };

  return (
    <Modal size="lg" isOpen={isOpen} toggle={toggle}>
      <div className="modal-header">
        <h5 className="modal-title mt-0">
          {servicoEditavel ? "Editar Serviço" : "Adicionar Serviço"}
        </h5>
        <button
          type="button"
          className="close"
          data-dismiss="modal"
          aria-label="Close"
          onClick={toggle}
        >
          <span aria-hidden="true">×</span>
        </button>
      </div>

      <LoadingModal isOpen={loading} text={text} />

      <Form onSubmit={handleSubmit}>
        <div className="modal-body">
          <Row form>
            <Col md={6}>
              <FormGroup>
                <Label for="area">Área</Label>
                <Input
                  type="select"
                  name="area"
                  id="area"
                  value={areaSelecionada}
                  onChange={(e) => setAreaSelecionada(e.target.value)}
                >
                  <option value="">Selecione...</option>
                  {areas.map((area) => (
                    <option key={area.AreaID} value={area.AreaID}>
                      {area.Nome}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="descricao">Descrição</Label>
                <Input
                  type="text"
                  name="descricao"
                  id="descricao"
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="valor">Valor à vista (1x)</Label>
                <Input
                  type="text"
                  name="valor"
                  id="valor"
                  value={valor}
                  onChange={(e) => setValor(e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="valorParcelado">Valor Total em 6x</Label>
                <Input
                  type="text"
                  name="valorParcelado"
                  id="valorParcelado"
                  value={valorParcelado}
                  readOnly
                />
              </FormGroup>
              <p>
                <small>{valorParcelado6x}</small>
              </p>
            </Col>

            <Col md={6}>
              <FormGroup>
                <Label for="statusSelect">Status</Label>
                <Input
                  type="select"
                  name="status"
                  id="statusSelect"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="">Selecione...</option>
                  <option value="Ativo">Ativo</option>
                  <option value="Inativo">Inativo</option>
                </Input>
              </FormGroup>
            </Col>

            <Col md={12}>
              <FormGroup>
                <Label for="mensagemAserExibida">
                  Mensagem a ser enviada para cliente após compra
                </Label>
                <Input
                  type="textarea"
                  name="mensagemAserExibida"
                  id="mensagemAserExibida"
                  value={mensagemAserExibida}
                  onChange={(e) => setMensagemAserExibida(e.target.value)}
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            {parcelas && (
              <Col md={12}>
                <h3>Valor das parcelas:</h3>
                {parcelas.map((parcela, index) => (
                  <p key={index}>
                    <small>
                      {parcela.QuantidadeParcelas}x de R${" "}
                      {parcela.ValorParcela / parcela.QuantidadeParcelas} sem
                      juros
                    </small>
                  </p>
                ))}
              </Col>
            )}
          </Row>
        </div>

        <div className="modal-footer">
          <Button type="button" color="secondary" onClick={toggle}>
            Cancelar
          </Button>
          <Button type="submit" color="primary">
            Salvar
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default AddServicoModal;
